import { scannerMenuItemsById, scannerMenuItemsByPath } from "./menuItems";

const normalizePath = (value: string) => {
  if (!value) {
    return "";
  }

  if (value === "/") {
    return value;
  }

  return value.endsWith("/") ? value.slice(0, -1) : value;
};

// Dynamic per-worktable routes (e.g. /worktable/3) are valid navigation targets
// even though they are not in the static menu item list.
const isDynamicNavigationPath = (path: string) => /^\/worktable\/\d+$/.test(path);

export const resolveScannerNavigationTarget = (value: string) => {
  const normalizedValue = value.trim();
  if (!normalizedValue) {
    return null;
  }

  const directPath = normalizePath(normalizedValue);
  if (scannerMenuItemsByPath.has(directPath) || isDynamicNavigationPath(directPath)) {
    return directPath;
  }

  if (scannerMenuItemsById.has(normalizedValue)) {
    return scannerMenuItemsById.get(normalizedValue)?.path ?? null;
  }

  try {
    const parsedUrl = new URL(normalizedValue);
    const normalizedPath = normalizePath(parsedUrl.pathname);

    if (scannerMenuItemsByPath.has(normalizedPath) || isDynamicNavigationPath(normalizedPath)) {
      return `${normalizedPath}${parsedUrl.search}${parsedUrl.hash}`;
    }
  } catch {
    return null;
  }

  return null;
};

export const buildNavigationQrUrl = (path: string) => {
  if (typeof window === "undefined") {
    return path;
  }

  return new URL(path, window.location.origin).toString();
};

export const buildNavigationQrImageUrl = (path: string, format: "png" | "svg" = "png") => {
  const targetUrl = buildNavigationQrUrl(path);
  const params = new URLSearchParams({
    size: "320x320",
    qzone: "2",
    format,
    data: targetUrl,
  });

  return `https://api.qrserver.com/v1/create-qr-code/?${params.toString()}`;
};
